import { errorColor, successColor, warningColor } from './styles'

export const ConfidenceLevels = {
    NOT_CONFIDENT: 1,
    MODERATELY_CONFIDENT: 2,
    CONFIDENT: 3,
    VERY_CONFIDENT: 4,
}

export const getConfidenceLevelName = confidenceLevel => {
    switch (confidenceLevel) {
        case ConfidenceLevels.NOT_CONFIDENT:
            return 'Not Confident'
        case ConfidenceLevels.MODERATELY_CONFIDENT:
            return 'Moderately Confident'
        case ConfidenceLevels.CONFIDENT:
            return 'Confident'
        case ConfidenceLevels.VERY_CONFIDENT:
            return 'Very Confident'
        default:
            return 'Unknown Confidence level'
    }
}

export const getConfidenceLevelNoun = confidenceLevel => {
    switch (confidenceLevel) {
        case ConfidenceLevels.NOT_CONFIDENT:
            return 'Lack of Confidence'
        case ConfidenceLevels.MODERATELY_CONFIDENT:
            return 'Moderate Confidence'
        case ConfidenceLevels.CONFIDENT:
            return 'Confidence'
        case ConfidenceLevels.VERY_CONFIDENT:
            return 'High Confidence'
        default:
            return 'Unknown Confidence level'
    }
}

export const getConfidenceLevelColor = confidenceLevel => {
    switch (confidenceLevel) {
        case ConfidenceLevels.NOT_CONFIDENT:
            return errorColor
        case ConfidenceLevels.MODERATELY_CONFIDENT:
            return warningColor
        case ConfidenceLevels.CONFIDENT:
            return successColor
        case ConfidenceLevels.VERY_CONFIDENT:
            return 'darkgreen'
        default:
            return '#333'
    }
}

export const getConfidenceLevelTagColor = confidenceLevel => {
    switch (confidenceLevel) {
        case ConfidenceLevels.NOT_CONFIDENT:
            return 'error'
        case ConfidenceLevels.MODERATELY_CONFIDENT:
            return 'warning'
        case ConfidenceLevels.CONFIDENT:
            return 'success'
        case ConfidenceLevels.VERY_CONFIDENT:
            return 'success'
        default:
            return '#processing'
    }
}
